/** 金额格式化辅助 */
export function useBillingAmount() {
  const formatAmount = (value: number | null | undefined): string => {
    if (value == null) return '0.00';
    return Number(value).toLocaleString('zh-CN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const isNegative = (value: number | null | undefined): boolean => {
    return value != null && value < 0;
  };

  const getAmountClass = (value: number | null | undefined): string => {
    return isNegative(value) ? 'amount-text negative' : 'amount-text positive';
  };

  return {
    formatAmount,
    isNegative,
    getAmountClass
  };
}
